import React from "react";
import { VariantProps } from ".";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import getPriceForGoogleView from "../getPriceForGoogleView";
const H = ({
  price,
  showBelowMinimumAdvertisedPriceForLoggedInCustomers,
  hasFreeShipping,
  hasWebPlusDiscountedShipping,
  isWebstaurantPlusEligible,
  isGoogleView,
  minimumBuy,
  mustBuy
}: VariantProps) => {
  return <>
      <div className="map map-override mapH">
        <AddToCartToSeePrice hasFreeShipping={hasFreeShipping} hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} hideWhyDoWeDoThis={price.hideWhyDoWeDoThis} isWebstaurantPlusEligible={isWebstaurantPlusEligible} showLowerPrice mapPrice={isGoogleView ? getPriceForGoogleView({
        price: price.minimumAdvertisedPriceProperties.price,
        minimumBuy,
        mustBuy
      }) : price.minimumAdvertisedPriceProperties.price} price={isGoogleView ? getPriceForGoogleView({
        price: price.price,
        minimumBuy,
        mustBuy
      }) : price.price} showLoginLink={showBelowMinimumAdvertisedPriceForLoggedInCustomers} showDetails showEnticement={isGoogleView} type={price.minimumAdvertisedPriceProperties.type} isGoogleView={isGoogleView} data-sentry-element="AddToCartToSeePrice" data-sentry-source-file="H.tsx" />
      </div>
    </>;
};
export default H;